export default __webpack_public_path__ + "static/media/coins-drop.92003099.svg";